/**
 * Route table for candidate-web. `/sign-in` is public; everything else sits behind
 * `RequireCandidate` (signed out → bounced to sign-in). Exported as a plain array so tests can mount
 * it under a memory router.
 *
 * WP-F8b landed the real `/request` wizard, the `/requests/:id` detail (timeline + unlock/letter
 * fan-out) and `/settings` (incl. account deletion) — replacing the WP-F8a Placeholders. The ledger
 * already links to them, so the whole app is walkable.
 */
import { Navigate, type RouteObject } from 'react-router-dom';
import { RequireCandidate } from '@/auth/RequireCandidate';
import { SignIn } from '@/routes/SignIn';
import { Ledger } from '@/routes/Ledger';
import { NewRequest } from '@/routes/NewRequest';
import { RequestDetail } from '@/routes/RequestDetail';
import { UnlockReturn } from '@/routes/UnlockReturn';
import { Referral } from '@/routes/Referral';
import { Settings } from '@/routes/Settings';

export const routes: RouteObject[] = [
  { path: '/sign-in', element: <SignIn /> },
  {
    element: <RequireCandidate />,
    children: [
      { path: '/', element: <Ledger /> },
      { path: '/request', element: <NewRequest /> },
      { path: '/requests/:id', element: <RequestDetail /> },
      // The Stripe hosted-Checkout return (WP-F11a) — forwards to the reference it belonged to.
      { path: '/unlock/return', element: <UnlockReturn /> },
      { path: '/referral', element: <Referral /> },
      { path: '/settings', element: <Settings /> },
    ],
  },
  // Unknown path → home, which itself bounces to sign-in when signed out.
  { path: '*', element: <Navigate to="/" replace /> },
];
